import { SendPayload, SendResponse } from '../../../Model/core';
import { post } from '../../../webapi';

export async function send(payload: SendPayload) {
    return await post<SendResponse>('/blApi/Send', { ...payload });
}